import { FieldSchema } from "@generation/core";
import { AllFieldTypes } from "../client/types/fieldTypes";

type FieldConverter<TFieldType extends AllFieldTypes> = (field: TFieldType) => FieldSchema;

export class FieldConverters {
  private converters: Record<string, FieldConverter<AllFieldTypes>> = {};

  registerConverter<TFieldType extends AllFieldTypes>(
    fieldType: string,
    converter: FieldConverter<TFieldType>
  ): void {
    this.converters[fieldType] = converter;
  }

  mapField = (field: AllFieldTypes): FieldSchema | undefined => {
    const fieldType = field.type;

    if (!fieldType) {
      return undefined;
    }

    const converter = this.converters[fieldType];

    if (converter) {
      return converter(field);
    }

    return undefined;
  };
}
